<template>
    <div class="ex-mark">
        <i @click="tipView">툴팁</i><span @click="tipView" v-show="tipOn">{{tipTxt}}</span>
    </div>
</template>

<script>
export default {
    props: {
        tipTxt: String,
    },
    data() {        
      return {
        tipOn : false,
      };
    },
    methods: {
        tipView: function(){
            this.tipOn = !this.tipOn;
        },
    },
};
</script>